import { Box } from '@factorialco/deprecated-design-system'
import { Button } from '@factorialco/factorial-one-react'
import { JoinExternalIntegrationFragment } from 'generated/resources/graphql'
import { startCase } from 'lodash'

import Modal from 'modules/core/components/Modal'
import TextField from 'modules/core/components/TextField'
import i18n from 'modules/core/lib/i18n'

import { ExternalProfileConfigurationFile } from './ExternalProfileConfigurationFile'
import { useUpdateIntegrationProfile } from './useUpdateIntegration'

interface Props {
  integrationProfile: JoinExternalIntegrationFragment
  onUpdated: () => void
  onClose: () => void
}

export const ExternalProfilesModal = ({ integrationProfile, onUpdated, onClose }: Props) => {
  const {
    fieldsErrors,
    integrationFile,
    configurationValues,
    updateIntegrationProfile,
    onConfigurationFileChange,
    onConfigurationValueChange,
  } = useUpdateIntegrationProfile({ integrationProfile })

  const handleUpdateIntegration = async () => {
    const result = await updateIntegrationProfile()

    result?.success && onUpdated()
  }

  return (
    <Modal title={integrationProfile.name} illustration="settings" onClose={onClose}>
      <Box gap="s16" alignItems="flexEnd" justifyContent="flexStart">
        {integrationProfile.configuration.map((option) =>
          option?.validationPattern === 'FILE' ? (
            <ExternalProfileConfigurationFile
              key={option.slug}
              option={option}
              currentFile={integrationFile}
              onFileChange={(file) => onConfigurationFileChange(file)}
            />
          ) : (
            <TextField
              key={option.slug}
              label={startCase(option.slug)}
              value={configurationValues[option.slug] || ''}
              placeholder={option.placeholder || undefined}
              error={
                fieldsErrors.includes(option.slug)
                  ? i18n.t('ats.settings.job_promotions.external_profiles.field_invalid_value')
                  : undefined
              }
              onChange={(value) => onConfigurationValueChange(option.slug, value)}
            />
          )
        )}

        <Button label={i18n.t('common.save')} onClick={handleUpdateIntegration} />
      </Box>
    </Modal>
  )
}
